import React, {Component} from 'react';

export const RECAPTCHA_ACTIONS = {
    LOGIN: 'LOGIN',
    REGISTER: 'REGISTER',
    VALIDATE_USER: 'VALIDATE_USER',
    VERIFY_CODE: 'VERIFY_CODE',
    RESEND_CODE: 'RESEND_CODE',
};

class Recaptcha extends Component {
    constructor(props) {
        super(props);
        this.onScriptLoad = this.onScriptLoad.bind(this)
    }

    onScriptLoad() {
        if (this.props.isFunction) {
            window.grecaptcha.enterprise.ready(() => {
                this.props.onReady();
            });
        }
    }


    componentDidMount() {
        const baseUri = 'https://www.google.com/recaptcha';
        const recaptchaV3Url = `${baseUri}/api.js?render=${window.CAPTCHA_LEGACY_KEY}`
        const recaptchaEnterpriseUrl = `${baseUri}/enterprise.js?render=${window.CAPTCHA_ENTERPRISE_KEY}`


        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.id = this.props.enterprise ? 'enterprise_recaptcha':'recaptcha_script';
        s.src = this.props.enterprise ? recaptchaEnterpriseUrl : recaptchaV3Url;
        var x = document.getElementById('root');
        x.appendChild(s);

        /* listen for google recaptcha script load event */
        s.addEventListener('load', e => {
            this.onScriptLoad();
        });
    }

    render() {
        return (
            <div id={this.props.id}/>
        );
    }
}

export default Recaptcha
